import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import TabsContainer from '../../molecules/TabsContainer';
import TransactionsTab from '../../organisms/TransactionsTab';
import { TransactionStatusTypes } from '../../../utils/constants';
import { fireAuth } from '../../../database/utils/firebase';
import { onSellerTransactionItems } from '../../../database/repositories/TransactionItemRepository';
import { compareSort } from '../../../utils/util';

function UserSales() {
  const { tab } = useParams();
  const [currentTab, setCurrentTab] = useState(tab ?? 'abertas');
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!fireAuth.currentUser?.uid) return;
    const subscribe = onSellerTransactionItems(setItems);
    return () => subscribe();
  }, [fireAuth.currentUser]);

  useEffect(() => {
    if (tab) setCurrentTab(tab);
  }, [tab]);

  const sortedItems = useMemo(
    () =>
      items.sort(
        compareSort(
          'status',
          currentTab === 'abertas' ? TransactionStatusTypes.Open : TransactionStatusTypes.Concluded
        )
      ),
    [items]
  );

  return (
    <S.Container>
      <Header />
      <NavBar />
      <MainContent>
        <S.UserSoldContainer>
          <ProfileCardMenu />

          <TabsContainer
            icon_code="fas fa-cash-register"
            title="VENDAS"
            tabs={[
              { title: 'EM ABERTO', url: '/usuario/vendas/abertas' },
              { title: 'CONCLUÍDAS', url: '/usuario/vendas/concluidas' }
            ]}>
            <TransactionsTab items={sortedItems} finished />
          </TabsContainer>
        </S.UserSoldContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default UserSales;
